import React from 'react';
import '@material/web/textfield/outlined-text-field.js';

// md-outlined-text-field only supports text/textarea/email/number/password/search/tel/url —
// it silently drops the native picker for these, so fall back to a plain <input>.
const NATIVE_ONLY_TYPES = ['date', 'datetime-local', 'time', 'month', 'week'];

/**
 * Input
 * Props: label, type, value, onChange, placeholder, error, hint, disabled, required
 */
const Input = ({
  label,
  error,
  hint,
  className = '',
  value,
  onChange,
  disabled,
  required,
  type = 'text',
  ...rest
}) => {
  if (NATIVE_ONLY_TYPES.includes(type)) {
    const defaultStep = (type === 'datetime-local' || type === 'time') ? 900 : undefined;
    return (
      <div className={`form-group ${className}`} style={{ marginBottom: 'var(--sp-4)' }}>
        {label && <label className="form-label">{label}</label>}
        <input
          type={type}
          step={rest.step ?? defaultStep}
          className="form-control"
          value={value ?? ''}
          onChange={onChange}
          disabled={disabled}
          required={required}
          {...rest}
        />
        {(error || hint) && (
          <span style={{ fontSize: 'var(--text-xs)', color: error ? 'var(--clr-danger)' : 'var(--clr-muted)', marginLeft: 4 }}>
            {error || hint}
          </span>
        )}
      </div>
    );
  }

  const handleInput = (e) => {
    if (onChange) {
      onChange({
        target: {
          value: e.target.value,
          name: e.target.name || rest.name,
        }
      });
    }
  };

  return (
    <div className={`form-group ${className}`} style={{ marginBottom: 'var(--sp-4)' }}>
      <md-outlined-text-field
        type={type}
        label={label}
        value={value ?? ''}
        placeholder={rest.placeholder || undefined}
        disabled={disabled || undefined}
        required={required || undefined}
        error={!!error || undefined}
        supporting-text={error || hint || ''}
        onInput={handleInput}
        style={{ width: '100%' }}
        {...rest}
      />
    </div>
  );
};

export default Input;
